// generated file: do not edit
import Bystander from "../../engine/bystander";
import Glyphs from "./glyphs";

class Bystanders {
  static reachVillager1(stage) {
    return new Bystander(
      "reachVillager1",
      Glyphs.ReachVillager1,
      8,
      {"look":"A young woman going about her business.","bump":"'{quips}'","quips":["“Hello!”","“It's warm today, isn't it?”","“See ya!”"]}
    );
  }
static chickens4(stage) {
    return new Bystander(
      "chickens4",
      Glyphs.Chickens4,
      8,
      {"look":"A cluster of chickens.","bump":"{barkDetail}","barkDetail":["(A cluster of chickens feeding on grain.)"]}
    );
  }
static fisher1(stage) {
    return new Bystander(
      "fisher1",
      Glyphs.Fisher1,
      8,
      {"look":"A {descriptive} fisherman, {moreDetail}","bump":"{barkDetail}","descriptive":["hungover","sleep-deprived","dull"],"moreDetail":["preparing his breakfast.","sniffling with a runny nose.","who still smells boozy."],"barkDetail":["“Hh-hey there, sorry I've only made some for myself.”","“Are you one of Shea's friends? She's a bad influence, trust me.”","“My boarder, Shea, is at work if you're looking for her.”","“Think it might rain soon?”"]}
    );
  }
static fisher2(stage) {
    return new Bystander(
      "fisher2",
      Glyphs.Fisher2,
      8,
      {"look":"A {descriptive} girl, {moreDetail}","bump":"{barkDetail}","descriptive":["bright-eyed","gentle","teenage"],"moreDetail":["feeding the chickens.","with a restless look about her.","with windswept sea-salt hair."],"barkDetail":["“Hey there. Pleasant day ain't it?”","“My brother's been sailing a lot lately. Makes me wish I'd go out more.”","“The water's really calm today!”","“Someone's gotta look after the chickens!”","“Mr. Briggs says I'm better at this than working in his stockroom. I know he's just saying that to get rid of me.”","“It's fine tho, I like it better out here. He's a creep anyway.”"]}
    );
  }
static fisher3(stage) {
    return new Bystander(
      "fisher3",
      Glyphs.Fisher3,
      8,
      {"look":"A {descriptive} fisherman, {moreDetail}","bump":"{barkDetail}","descriptive":["foolish and self-important","focused","hopeful but misguided"],"moreDetail":["fishing off the rocks","with a net in the waters below.","who sank his boat last week and hasn't yet recovered."],"barkDetail":["“A g'day for fishing, ain't it?”","“It's been real hard without my boat.”","“My boy's been havin' fishing lessons, bless'im.”","“Just gotta be patient...”"]}
    );
  }
static fisher4(stage) {
    return new Bystander(
      "fisher4",
      Glyphs.Fisher4,
      8,
      {"look":"A {descriptive} fisherwoman, {moreDetail}","bump":"{barkDetail}","descriptive":["stern","restless","tired"],"moreDetail":["sunbathing on the beach.","trying (and failing) to tan.","who looks like she's coming to terms with a loss."],"barkDetail":["“My husband sank his boat last week, can you believe it?”","“I told him not to fish near those rocks, but does he listen?”","“So there goes any hope of moving to Nelson's Reach anytime soon.”","“At least the kids have taken up some work around here.”","“Oh, I'll forgive him eventually. Until then, you're blocking my sun.”"]}
    );
  }
static boot(stage) {
    return new Bystander(
      "boot",
      Glyphs.Boot,
      8,
      {"look":"An old leather boot, {descriptive}.","bump":"An old leather boot, {descriptive}.","descriptive":["wet with seawater","that smells of gunpowder and rum","unlike those most Calderans seem to wear.."]}
    );
  }
static bruno(stage) {
    return new Bystander(
      "bruno",
      Glyphs.Bruno,
      8,
      {"look":"A dog, {moreDetail}","bump":"{barkDetail}","moreDetail":["wagging his tail excitedly.","panting in the sunlight.","being very well-behaved."],"barkDetail":["“Who's a good boy?”","“You are, yes you are!”","(Bark, borf!)"]}
    );
  }
static chickens_2(stage) {
    return new Bystander(
      "chickens_2",
      Glyphs.Chickens_2,
      8,
      {"look":"A cluster of chickens.","bump":"{barkDetail}","barkDetail":["(A cluster of chickens feeding on grain.)"]}
    );
  }
static chickens_3(stage) {
    return new Bystander(
      "chickens_3",
      Glyphs.Chickens_3,
      8,
      {"look":"A cluster of chickens.","bump":"{barkDetail}","barkDetail":["(A cluster of chickens wandering about.)"]}
    );
  }
static chickens(stage) {
    return new Bystander(
      "chickens",
      Glyphs.Chickens,
      8,
      {"look":"A cluster of chickens.","bump":"{barkDetail}","barkDetail":["(A cluster of chickens feeding on grain.)"]}
    );
  }
static cow_2(stage) {
    return new Bystander(
      "cow_2",
      Glyphs.Cow_2,
      8,
      {"look":"A cow, grazing lazily.","bump":"{barkDetail}","barkDetail":["(A cow grazing lazily.)"]}
    );
  }
static cow_3(stage) {
    return new Bystander(
      "cow_3",
      Glyphs.Cow_3,
      8,
      {"look":"A cow, grazing lazily.","bump":"{barkDetail}","barkDetail":["(A cow grazing lazily.)"]}
    );
  }
static cow(stage) {
    return new Bystander(
      "cow",
      Glyphs.Cow,
      8,
      {"look":"A cow, grazing lazily.","bump":"{barkDetail}","barkDetail":["(A cow grazing lazily.)"]}
    );
  }
static farmer_angry(stage) {
    return new Bystander(
      "farmer_angry",
      Glyphs.Farmer_angry,
      8,
      {"look":"A farmsteader, {moreDetail}","bump":"{barkDetail}","moreDetail":["drinking himself dizzy.","swearing at the walls, out the windows, at the dog...","already on his fifth glass of wine and considering opening another bottle."],"barkDetail":["“They can piss off with their fancy clothes, an'...”","“...sense of dignity, an' pride...”","“I've lived here my whole life an' I'll die here!”","“What money do they think could buy my family home?”","“I won't have it! None of us're leaving!”","“They can piss off, they can piss off...”","“...and they can just sail in here and pay for what they want...”","“Where's the justice in that? Huuh?”","“Meanwhile hard workin' folks like me - ”","“What are you looking at?”","“(Groans, losing his balance.)”","“...I wish I had money like that, an' I could piss on family legacy...”","“(Wailing uncontrollably.)”","“They can piss offff!”"]}
    );
  }
static farmer_glad(stage) {
    return new Bystander(
      "farmer_glad",
      Glyphs.Farmer_glad,
      8,
      {"look":"{descriptive} farmer, {moreDetail}","bump":"{barkDetail}","descriptive":["An exhausted","A worn out","A haggard"],"moreDetail":["covered in dirt.","swearing at his fields.","sweating in the harsh sun."],"barkDetail":["“Ohh I'll be glad to be rid of this homestead one day.”","“What I would give to sell up and live a comfortable life on the sea.”","“(Exhuasted sigh.)”"]}
    );
  }
static farmer_indifferent(stage) {
    return new Bystander(
      "farmer_indifferent",
      Glyphs.Farmer_indifferent,
      8,
      {"look":"A rugged farmer, {moreDetail}","bump":"{barkDetail}","moreDetail":["coated in manure.","digging up unwanted plants.","sweating in the harsh sun."],"barkDetail":["“So what if they want my land? As long as they can pay for it!”","“Oh, I'll be a rich man someday. Yes, I will.”","“Ugh, I've had enough of shit and stale bread.”"]}
    );
  }
static farmer_working(stage) {
    return new Bystander(
      "farmer_working",
      Glyphs.Farmer_working,
      8,
      {"look":"A stern farmer, {moreDetail}","bump":"{barkDetail}","moreDetail":["digging up weeds.","trying to harvest vegetables without much luck.","cursing under her breath."],"barkDetail":["“Don't go inside, my husband's boozing his problems away.”","“Ohh my head hurts.”","“I'd rather work out here alone, thanks. I've had enough talking about rumours for one day.”"]}
    );
  }
static oversleptPirate(stage) {
    return new Bystander(
      "oversleptPirate",
      Glyphs.OversleptPirate,
      8,
      {"look":"A Pirate! Laying atop a bag of sand... {moreDetail}","bump":"{barkDetail}","moreDetail":["He looks like he overslept.","He's missing a boot...","He smells of booze and sweat."],"barkDetail":["“Arr, I must've slept past dawn!”","“Curse them all! Thar'll be hell t'pay fer this, mark me words!”","“Arr, nothin' t'see here mate, that's close enough!”","(Yawning.)"]}
    );
  }
static suspiciousMen1(stage) {
    return new Bystander(
      "suspiciousMen1",
      Glyphs.SuspiciousMen1,
      8,
      {"look":"A Suspicious Man, {moreDetail}","bump":"{barkDetail}","moreDetail":["holding an instrument you cannot recognise.","measuring something in the distance with a sextant.","murmuring to his colleagues."],"barkDetail":["(He has nothing to say to you.)"]}
    );
  }
static suspiciousMen2(stage) {
    return new Bystander(
      "suspiciousMen2",
      Glyphs.SuspiciousMen2,
      8,
      {"look":"A Suspicious Man, {moreDetail}","bump":"{barkDetail}","moreDetail":["examining a sample of rock.","murmuring with his colleagues.","his eyes surveying the inlet."],"barkDetail":["(He has nothing to say to you.)"]}
    );
  }
static wolf1(stage) {
    return new Bystander(
      "wolf1",
      Glyphs.Wolf1,
      8,
      {"look":"A hungry wolf, but not the pack leader.","bump":"{barkDetail}","barkDetail":["(Growling.)"]}
    );
  }
static wolf2(stage) {
    return new Bystander(
      "wolf2",
      Glyphs.Wolf2,
      8,
      {"look":"A hungry wolf, but not the pack leader.","bump":"{barkDetail}","barkDetail":["(Growling.)"]}
    );
  }
static lytteltonStudent(stage) {
    return new Bystander(
      "lytteltonStudent",
      Glyphs.LytteltonStudent,
      8,
      {"look":"A smart young man. {moreDetail}","bump":"{barkDetail}","moreDetail":["He sees you and turns the other way.","He is hard at work with a tiny artefact.","A cough comes from his direction."],"barkDetail":["“Oh, uh, hello there.”","“I would appreciate if you watched your step, please.”","“I've got to impress the professor.”","“Isn't the professor a brilliant man!”"]}
    );
  }
static sumnerWorker(stage) {
    return new Bystander(
      "sumnerWorker",
      Glyphs.SumnerWorker,
      8,
      {"look":"A short and sneaky individual. {moreDetail}","bump":"{barkDetail}","moreDetail":["He sees you and busies himself.","A crash comes from the wood he dumps on the ground.","He glares. Maybe he doesn't trust you."],"barkDetail":["“Watch where you're going, okay?”","“Humpf.”","“I'm kinda busy here.”","“You been talking to Sumner a lot?”"]}
    );
  }
static Farmvillager1(stage) {
    return new Bystander(
      "Farmvillager1",
      Glyphs.Farmvillager1,
      8,
      {"look":"{moreDetail} harvesting the fields.","bump":"{villager1Quips}","villager1Quips":["“Hello and welcome!”","“Good day to you, sir.”","“How are you today?”"],"moreDetail":["An old woman","An old man","A young boy","A young woman"]}
    );
  }
static Farmvillager2(stage) {
    return new Bystander(
      "Farmvillager2",
      Glyphs.Farmvillager2,
      8,
      {"look":"{moreDetail} harvesting the fields.","bump":"{villager1Quips}","villager1Quips":["“Hello and welcome!”","“Good day to you, sir.”","“How are you today?”"],"moreDetail":["An old woman","An old man","A young boy","A young woman"]}
    );
  }
static guestroomguy(stage) {
    return new Bystander(
      "guestroomguy",
      Glyphs.Guestroomguy,
      8,
      {"look":"{moreDetail}","bump":"{villager1Quips}","villager1Quips":["“Hello there, feel free to pick one of these guest rooms if you're planning on staying.”"],"moreDetail":["A well-dressed man standing very still.","A well-dressed woman standing motionless."]}
    );
  }
static standowner1(stage) {
    return new Bystander(
      "standowner1",
      Glyphs.Standowner1,
      8,
      {"look":"A stand selling food.","bump":"{villager1Quips}","villager1Quips":["“Hello and welcome. Let me know if you need anything.”"]}
    );
  }
static standowner2(stage) {
    return new Bystander(
      "standowner2",
      Glyphs.Standowner2,
      8,
      {"look":"A stand selling flowers.","bump":"{villager1Quips}","villager1Quips":["“Hello and welcome. Let me know if you need anything.”"]}
    );
  }
static standowner3(stage) {
    return new Bystander(
      "standowner3",
      Glyphs.Standowner3,
      8,
      {"look":"A stand selling groceries.","bump":"{villager1Quips}","villager1Quips":["“Hello and welcome. Let me know if you need anything.”"]}
    );
  }
static standowner4(stage) {
    return new Bystander(
      "standowner4",
      Glyphs.Standowner4,
      8,
      {"look":"Ths stand is still preparing.","bump":"{villager1Quips}","villager1Quips":["Hello, sorry, we're still preparing. Do come back later!"]}
    );
  }
static villagekids1(stage) {
    return new Bystander(
      "villagekids1",
      Glyphs.Villagekids1,
      8,
      {"look":"Two kids playing games together.","bump":"(They don't say anything, but stare at you.)"}
    );
  }
static villagekids2(stage) {
    return new Bystander(
      "villagekids2",
      Glyphs.Villagekids2,
      8,
      {"look":"Two kids playing games together.","bump":"(They don't say anything, but stare at you.)"}
    );
  }
static villagelady1(stage) {
    return new Bystander(
      "villagelady1",
      Glyphs.Villagelady1,
      8,
      {"look":"{moreDetail} enjoying some gossip.","bump":"{villager1Quips}","villager1Quips":["“Hello.”","“Good day to you.”"],"moreDetail":["An old woman","An young woman"]}
    );
  }
static villagelady2(stage) {
    return new Bystander(
      "villagelady2",
      Glyphs.Villagelady2,
      8,
      {"look":"{moreDetail} enjoying some gossip.","bump":"{villager1Quips}","villager1Quips":["“Hello.”","“Good day to you.”"],"moreDetail":["An old woman","An young woman"]}
    );
  }
static wearhousecounterguy(stage) {
    return new Bystander(
      "wearhousecounterguy",
      Glyphs.Wearhousecounterguy,
      8,
      {"look":"A man performing a stock count of the village food supply.","bump":"“I am sorry, I'm a bit busy right now. Go talk to the head of the village if you need anything.”"}
    );
  }
static wearhouseman1(stage) {
    return new Bystander(
      "wearhouseman1",
      Glyphs.Wearhouseman1,
      8,
      {"look":"A young man loading items onto the shelves.","bump":"{villager1Quips}","villager1Quips":["“Where should I put this?”"]}
    );
  }
static wearhouseman2(stage) {
    return new Bystander(
      "wearhouseman2",
      Glyphs.Wearhouseman2,
      8,
      {"look":"A middle-aged man loading the shelves.","bump":"{villager1Quips}","villager1Quips":["“Sorry, I am busy here. If you need anything go talk to the head of the village.”"]}
    );
  }
static Miner1(stage) {
    return new Bystander(
      "Miner1",
      Glyphs.Miner1,
      8,
      {"look":"A burly looking miner lays slumped over, {moreDetail}","bump":"{barkDetail}","moreDetail":["his pick laying across his legs.","has pack behind him.","collecting himself on the cold hard ground."],"barkDetail":["“I can't belive the Chief is dead.”","“What a terrible sight. That poor man.”","“Jackass diserved it.”","“Leave me alone.”","“Hope my wife is okay.”"]}
    );
  }
static Miner2(stage) {
    return new Bystander(
      "Miner2",
      Glyphs.Miner2,
      8,
      {"look":"A burly looking miner lays slumped over, {moreDetail}","bump":"{barkDetail}","moreDetail":["his pick laying across his legs.","his pack behind him.","collecting himself on the cold hard ground."],"barkDetail":["“Shit. What's going to happen to the rest of us?”","“Who's going to do the dangerous shit now he's gone?”","“I dont know if I'd rather it was a monster...”","“I wonder how the kid's holding up...”","“Hope my wife is okay.”"]}
    );
  }
static Miner3(stage) {
    return new Bystander(
      "Miner3",
      Glyphs.Miner3,
      8,
      {"look":"A burly looking miner lays slumped over, {moreDetail}","bump":"{barkDetail}","moreDetail":["his pick laying across his legs.","his pack behind him.","collecting himself on the cold hard ground."],"barkDetail":["“Wonder if that rich mayor had anything to do with this?”","“Who's going to do the dangerous shit now he's gone?”","“Can't believe what that kid says. I've never seen anything like that.”","“That Priest has been hanging about lately. Wonder what he wants?”","“I just want to go home.”"]}
    );
  }
static MiningVillager1(stage) {
    return new Bystander(
      "MiningVillager1",
      Glyphs.MiningVillager1,
      8,
      {"look":"A Townswoman, {moreDetail}","bump":"{barkDetail}","moreDetail":["standing in the street.","cleaning her house.","collecting herself."],"barkDetail":["“Hmm, where'd I put that?”","“What a terrible sight. That poor man.”","“I'm sorry, I can't help.”","“Hello.”","“Hope everything goes back to normal soon.”"]}
    );
  }
static MiningVillager10(stage) {
    return new Bystander(
      "MiningVillager10",
      Glyphs.MiningVillager10,
      8,
      {"look":"An elderly Townswoman, {moreDetail}","bump":"{barkDetail}","moreDetail":["sitting on a church chair."],"barkDetail":["“Hello sonny.”","“What a terrible sight. That poor man...”","“The Priest is such a nice man.”","“I remember when the Priest was younger, such a strapping lad.”","“I wish the Mayor got along better with the Priest.”"]}
    );
  }
static MiningVillager11(stage) {
    return new Bystander(
      "MiningVillager11",
      Glyphs.MiningVillager11,
      8,
      {"look":"A Townsman, {moreDetail}","bump":"{barkDetail}.","moreDetail":["sitting on a church chair."],"barkDetail":["“The Priest is really fired up today.”","“Haven't seen the Priest like this since that kid died in the mine.”","“Why do we even have that Mayor if he isn't going to do anything?”","“The Chief had it coming to him.”","“Wish that spoiled Mayor would help this damn town.”"]}
    );
  }
static MiningVillager12(stage) {
    return new Bystander(
      "MiningVillager12",
      Glyphs.MiningVillager12,
      8,
      {"look":"A Townswoman, {moreDetail}","bump":"{barkDetail}","moreDetail":["bent over the well.","collecting water from the well.","drinking some water."],"barkDetail":["“I wish there was an easier way to do this.”","“What a terrible sight. That poor man.”","“Sorry, this is for the Mayor. You'll have to wait.”","“Hello...”","“Haven't seen you around here before?”"]}
    );
  }
static MiningVillager13(stage) {
    return new Bystander(
      "MiningVillager13",
      Glyphs.MiningVillager13,
      8,
      {"look":"A Townsman, {moreDetail}","bump":"{barkDetail}","moreDetail":["back turned, cleaning a bench."],"barkDetail":["“How'd you get in here?”"]}
    );
  }
static MiningVillager14(stage) {
    return new Bystander(
      "MiningVillager14",
      Glyphs.MiningVillager14,
      8,
      {"look":"A Townsman dressed up in crude armour, {moreDetail}","bump":"{barkDetail}","moreDetail":["standing in the street in front of a large door."],"barkDetail":["“No entrance to the warehouse.”","“Buzz off.”","“I'm sorry, I can't help.”","“Move along.”","“We are investigating the death of the Chief.”"]}
    );
  }
static MiningVillager15(stage) {
    return new Bystander(
      "MiningVillager15",
      Glyphs.MiningVillager15,
      8,
      {"look":"A Townsman, {moreDetail}","bump":"{barkDetail}","moreDetail":["kneeling in some dirt.","tending to some plants.","collecting himself."],"barkDetail":["“Hmm, where'd I put that?”","“What a terrible sight. That poor man.”","“I'm sorry, I can't help.”","“Hello?”","“Hope everything goes back to normal soon.”"]}
    );
  }
static MiningVillager16(stage) {
    return new Bystander(
      "MiningVillager16",
      Glyphs.MiningVillager16,
      8,
      {"look":"A Townswoman, {moreDetail}","bump":"{barkDetail}","moreDetail":["cleaning her home.","moving about her home.","collecting herself."],"barkDetail":["“How'd you even get in here?”"]}
    );
  }
static MiningVillager17(stage) {
    return new Bystander(
      "MiningVillager17",
      Glyphs.MiningVillager17,
      8,
      {"look":"A Townswoman, {moreDetail}","bump":"{barkDetail}","moreDetail":["cleaning her home.","moving about her home.","collecting herself."],"barkDetail":["“How'd you even get in here?”"]}
    );
  }
static MiningVillager18(stage) {
    return new Bystander(
      "MiningVillager18",
      Glyphs.MiningVillager18,
      8,
      {"look":"A Townsman, {moreDetail}","bump":"{barkDetail}","moreDetail":["cleaning the street.","tending to the grass.","watering plants."],"barkDetail":["“Stupid Mayor and his high standards...”","“Who made him Mayor again?”","“Serves the Chief right for working with the Mayor.”","“Sod off.”","“Stupid plants.”"]}
    );
  }
static MiningVillager19(stage) {
    return new Bystander(
      "MiningVillager19",
      Glyphs.MiningVillager19,
      8,
      {"look":"A small child, {moreDetail}","bump":"{barkDetail}","moreDetail":["hiding."],"barkDetail":["“Dang, you found me.”"]}
    );
  }
static MiningVillager2(stage) {
    return new Bystander(
      "MiningVillager2",
      Glyphs.MiningVillager2,
      8,
      {"look":"A small child, {moreDetail}.","bump":"{barkDetail}","moreDetail":["hiding against the tree.","climbing around in a tree.","playing with sticks."],"barkDetail":["“Hello.”","“I'm not supposed to talk to strangers.”","“Go away.”","“Plllttt” (the child sticks out his tongue.)","“Don't tell my Mum I'm here.”"]}
    );
  }
static MiningVillager3(stage) {
    return new Bystander(
      "MiningVillager3",
      Glyphs.MiningVillager3,
      8,
      {"look":"A Townswoman, {moreDetail}","bump":"{barkDetail}.","moreDetail":["clearing a small garden.","tending to some plants.","kneeling in the dirt."],"barkDetail":["“Hmm, hmm, hmm.”","“It was nice of the priest to give me some seeds.”","“Unless you want to help plant, buzz off.”","“Hello?”","“I hope that it's not a monster, like the Priest says...”"]}
    );
  }
static MiningVillager4(stage) {
    return new Bystander(
      "MiningVillager4",
      Glyphs.MiningVillager4,
      8,
      {"look":"An old Townsman, {moreDetail}","bump":"{barkDetail}","moreDetail":["with grey hair and outdated clothing.","sleeping on a chair.","rocking back and forth on his chair."],"barkDetail":["(zzzzzzzzzz)"]}
    );
  }
static MiningVillager5(stage) {
    return new Bystander(
      "MiningVillager5",
      Glyphs.MiningVillager5,
      8,
      {"look":"A Townswoman, {moreDetail}","bump":"{barkDetail}","moreDetail":["cleaning her home.","moving about her home.","collecting herself."],"barkDetail":["“How'd you even get in here?”"]}
    );
  }
static MiningVillager6(stage) {
    return new Bystander(
      "MiningVillager6",
      Glyphs.MiningVillager6,
      8,
      {"look":"A Townswoman, {moreDetail}","bump":"{barkDetail}","moreDetail":["looking out at the trees.","watching her child play.","collecting herself."],"barkDetail":["“It's nice of the Priest to offer to watch the children at a time like this.”","“What a terrible sight. That poor man.”","“Can't let my son see that mess out front.”","“Hello.”","“Hope everything goes back to normal soon.”"]}
    );
  }
static MiningVillager7(stage) {
    return new Bystander(
      "MiningVillager7",
      Glyphs.MiningVillager7,
      8,
      {"look":"A child, {moreDetail}","bump":"{barkDetail}","moreDetail":["playing amongst the trees.","running around.","swinging a stick around."],"barkDetail":["“Wanna play?”","“What'ca doin?”","“Ha, whoo!”","“Hello!”","“Wanna stick?”"]}
    );
  }
static MiningVillager8(stage) {
    return new Bystander(
      "MiningVillager8",
      Glyphs.MiningVillager8,
      8,
      {"look":"A Townsman, {moreDetail}","bump":"{barkDetail}","moreDetail":["coming out of his home.","holding mining gear.","collecting himself."],"barkDetail":["“A shame about the Chief...”","“That man had it comming for what he's done.”","“The Priest claims it's the work of some monster.”","“Have you seen the Mayors house? How'd a man get that much money?”","“Nothing ever gets fixed around here.”"]}
    );
  }
static MiningVillager9(stage) {
    return new Bystander(
      "MiningVillager9",
      Glyphs.MiningVillager9,
      8,
      {"look":"A Townswoman, {moreDetail}","bump":"{barkDetail}","moreDetail":["cooking at a small stove."],"barkDetail":["“How'd you get in here?”"]}
    );
  }
static MVINPC_MineChief(stage) {
    return new Bystander(
      "MVINPC_MineChief",
      Glyphs.MVINPC_MineChief,
      8,
      {"look":"{moreDetail}","bump":"{barkDetail}","moreDetail":["A mangled corpse lays spread on the ground, surrounded by a pool of blood. Several limbs are missing and the body is torn from scratches and bite marks. A smear of blood points in the direction of the mine."],"barkDetail":["You try to examine the body, but as you get closer you decide against it."]}
    );
  }
static dweller1(stage) {
    return new Bystander(
      "dweller1",
      Glyphs.Dweller1,
      8,
      {"look":"A Miner, {moreDetail}","bump":"{barkDetail}","moreDetail":["eating his breakfast and staring out to sea.","who hasn't heard of washing his hands, it seems.","who looks like the light has died within him."],"barkDetail":["“You're not from around here... what are you doing here?”","“I've got a shift in a couple hours.”","“My mate Sam's hurt his shoulder, poor snowflake. He's up the hill a bit, tell'm to harden up.”","(Grunts, disinterested in what you have to say.)"]}
    );
  }
static dweller2(stage) {
    return new Bystander(
      "dweller2",
      Glyphs.Dweller2,
      8,
      {"look":"An Office Worker, {moreDetail}","bump":"{barkDetail}","moreDetail":["filing papers in a drawer.","making herself busy, on what must be her day off. There must not be much to do here."],"barkDetail":["“The office is closed. If you want to apply for work, you'll have to talk to the Mining Chief in Bedrock Bastion.”","“I haven't heard anything about any rumours, and I don't care to know.”","“You look strong, why don't you help the old man on the dock?”"]}
    );
  }
static dweller3(stage) {
    return new Bystander(
      "dweller3",
      Glyphs.Dweller3,
      8,
      {"look":"A middle-aged man, smoking by himself in the foundations of a building long gone.","bump":"{barkDetail}","barkDetail":["“Haven't seen you before.”","“Saw that old man dragging bags to the docks, poor bastard. Must not have money for rent.”","“Let me smoke in peace. You want to chat? That Miner up on the hill won't shut up.”","(Smokes, disinterested.)"]}
    );
  }
static aveline(stage) {
    return new Bystander(
      "aveline",
      Glyphs.Aveline,
      8,
      {"look":"A sailor, {moreDetail}","bump":"{barkDetail}","moreDetail":["rescued from the Beast.","recovering well after months at sea.","from a distant shore."],"barkDetail":["“I feel like we should leave flowers, or something.”","“I wonder if there were any other survivors...”","“Oh, hello.”","“I still can't remember anything.”","“So this is where the Captain lived.”"]}
    );
  }
static buriedTreasure(stage) {
    return new Bystander(
      "buriedTreasure",
      Glyphs.BuriedTreasure,
      8,
      {"look":"Is that... buried treasure??","bump":"Maybe the real treasure was {barkDetail}","barkDetail":["the friends we made along the way.","the journey, not the destination.","what you make of it.","inside you all along.","too good to be true.","in another castle.","a lie.","an adventurer like you, but then it took an arrow in... the... knee..?","to try, try again.","learning that not all deeds yield reward.","among us.","coming from inside the building.","erusaert spelled backwards.","something intangible, perculiar perhaps, beyond description.","cycling through all of these text quips on a virtual deserted island instead of whatever it is you're supposed to be doing."]}
    );
  }
static canons(stage) {
    return new Bystander(
      "canons",
      Glyphs.Canons,
      8,
      {"look":"The towering cliff face of Nelson's Reach, with its canons brazenly pointed at the sea.","bump":"{barkDetail}","barkDetail":["“Them canons make me nervous.”","“Arr, look up at the Reach, she's magnificent, ain't she?”","“There's the cowards, holed up in their keep!”","“I'm not here! Someone hide me, please!”"]}
    );
  }
static debris1(stage) {
    return new Bystander(
      "debris1",
      Glyphs.Debris1,
      8,
      {"look":"Debris, from an unknown wreck...","bump":"{barkDetail}","barkDetail":["“What is that? In the water?”","“Captain, debris! Where'd it come from?”"]}
    );
  }
static debris2(stage) {
    return new Bystander(
      "debris2",
      Glyphs.Debris2,
      8,
      {"look":"Debris, from an unknown wreck...","bump":"{barkDetail}","barkDetail":["“Look, Cap'n! Another!”","“Where are they coming from?”","“Should we investigate?”"]}
    );
  }
static debris3(stage) {
    return new Bystander(
      "debris3",
      Glyphs.Debris3,
      8,
      {"look":"Debris, from an unknown wreck...","bump":"{barkDetail}","barkDetail":["“Ay, Captain! There's more debris!”","“They're like breadcrumbs...”","“Should we investigate?”"]}
    );
  }
static haunterA(stage) {
    return new Bystander(
      "haunterA",
      Glyphs.HaunterA,
      8,
      {"look":"Aveline... {moreDetail}","bump":"Aveline... {moreDetail}","moreDetail":["She's staring out to the horizon.","Is this what she saw for those months at sea?","What weary eyes. They look as though they aren't hers."],"barkDetail":["“Stay away from th' waters if ye value yer life.”","“Ask th' others, they'll tell ye.”","“No one believes an old mariner's tale.”","(Unintelligible muttering)"]}
    );
  }
static haunterG(stage) {
    return new Bystander(
      "haunterG",
      Glyphs.HaunterG,
      8,
      {"look":"Genevieve? {moreDetail}","bump":"Genevieve? {moreDetail}","moreDetail":["She's staring out to the horizon. There's nothing behind her eyes.","You wave a hand in front of her face. She does not blink.","Since when did she have such weary eyes?"],"barkDetail":["“Stay away from th' waters if ye value yer life.”","“Ask th' others, they'll tell ye.”","“No one believes an old mariner's tale.”","(Unintelligible muttering)"]}
    );
  }
static haunterJ(stage) {
    return new Bystander(
      "haunterJ",
      Glyphs.HaunterJ,
      8,
      {"look":"Joshua...? {moreDetail}","bump":"Joshua...? {moreDetail}","moreDetail":["He's staring out to the horizon. There's nothing out there.","He doesn't appear to be breathing.","His eyes are weary."],"barkDetail":["“Stay away from th' waters if ye value yer life.”","“Ask th' others, they'll tell ye.”","“No one believes an old mariner's tale.”","(Unintelligible muttering)"]}
    );
  }
static haunterS(stage) {
    return new Bystander(
      "haunterS",
      Glyphs.HaunterS,
      8,
      {"look":"Shea... {moreDetail}","bump":"Shea... {moreDetail}","moreDetail":["She's staring out to the horizon, like the others.","Is this where she goes in her dreams? You shudder at the thought.","She shouldn't have such weary eyes."],"barkDetail":["“Stay away from th' waters if ye value yer life.”","“Ask th' others, they'll tell ye.”","“No one believes an old mariner's tale.”","(Unintelligible muttering)"]}
    );
  }
static haunterW(stage) {
    return new Bystander(
      "haunterW",
      Glyphs.HaunterW,
      8,
      {"look":"William?... {moreDetail}","bump":"William?... {moreDetail}","moreDetail":["He won't stop staring out to the horizon.","","You feel those weary eyes watching you when you aren't facing him."],"barkDetail":["“Stay away from th' waters if ye value yer life.”","“Ask th' others, they'll tell ye.”","“No one believes an old mariner's tale.”","(Unintelligible muttering)"]}
    );
  }
static isolationist(stage) {
    return new Bystander(
      "isolationist",
      Glyphs.Isolationist,
      8,
      {"look":"A Pirate, {moreDetail}","bump":"{barkDetail}","moreDetail":["seemingly marooned on the island.","drinking rum and staring out to sea.","who smells of booze and saltwater."],"barkDetail":["“No - no, I'm no' goin' back out there!”","“Leave me be - this's my home now.”","“Yer fools 'f ya wanna go lookin' for't!”","“Oh God, tha' thing's still up North, I can hear't...”","(Drunken rambling.)"]}
    );
  }
static isolationist2(stage) {
    return new Bystander(
      "isolationist2",
      Glyphs.Isolationist2,
      8,
      {"look":"A fisherman, {moreDetail}","bump":"{barkDetail}","moreDetail":["by the looks of it?","but where's his boat?","who seems surprised to see us."],"barkDetail":["“Oh! Mary, look, Mary! We've got guests!”","“Oh, oh, I apologise! I didn't know you were coming...”","“Make yourselves at home, we haven't much to offer, but the fish are plentiful!”","“Mary, tell our guests that story - the one you told last week! I haven't stopped laughing!”","Ha! Hah haha..."]}
    );
  }
static isolationist3(stage) {
    return new Bystander(
      "isolationist3",
      Glyphs.Isolationist3,
      8,
      {"look":"A goat, {moreDetail}","bump":"{barkDetail}","moreDetail":["eating the remains of an old boot.","chewing on grass, lazily.","with devil eyes."],"barkDetail":["(Baaa!)"]}
    );
  }
static openSea(stage) {
    return new Bystander(
      "openSea",
      Glyphs.OpenSea,
      8,
      {"look":"The open waters beyond the Caldera call to many a sailor, but it'd be unwise to think the Oddsea an ocean vessel.","bump":"{barkDetail}","barkDetail":["“Oi, Captain, the Oddsea's not equipp'd for the open seas!”","“Arr, best be avoidin' open waters, lest we wind up'n the drink.”","“Turn back, Cap'n, she won't take the open waters!”"]}
    );
  }
static rocks(stage) {
    return new Bystander(
      "rocks",
      Glyphs.Rocks,
      8,
      {"look":"Jagged rocks breaking the water's surface.","bump":"{barkDetail}","barkDetail":["“Cap'n, I think we should avoid th' rocks!”","“Are y' tryin' ta dash us against the rocks, Captain?”","“We can't make port here, Captain!”"]}
    );
  }
static rocks10(stage) {
    return new Bystander(
      "rocks10",
      Glyphs.Rocks10,
      8,
      {"look":"A good habitat for barnacles, but for ye I think not.","bump":"{barkDetail}","barkDetail":["“Cap'n, I think we should avoid th' rocks!”","“Are y' tryin' ta dash us against the rocks, Captain?”","“We can't make port here, Captain!”"]}
    );
  }
static rocks11(stage) {
    return new Bystander(
      "rocks11",
      Glyphs.Rocks11,
      8,
      {"look":"The hungry maw of an inlet, ringed with jagged teeth, waiting to claim its prey.","bump":"{barkDetail}","barkDetail":["“Cap'n, I think we should avoid th' rocks!”","“Are y' tryin' ta dash us against the rocks, Captain?”","“We can't make port here, Captain!”"]}
    );
  }
static rocks12(stage) {
    return new Bystander(
      "rocks12",
      Glyphs.Rocks12,
      8,
      {"look":"Get closer, and have a long salt drink.","bump":"{barkDetail}","barkDetail":["“Cap'n, I think we should avoid th' rocks!”","“Are y' tryin' ta dash us against the rocks, Captain?”","“We can't make port here, Captain!”"]}
    );
  }
static rocks2(stage) {
    return new Bystander(
      "rocks2",
      Glyphs.Rocks2,
      8,
      {"look":"A cluster of sharp boulders peaking through the waves.","bump":"{barkDetail}","barkDetail":["“Cap'n, I think we should avoid th' rocks!”","“Are y' tryin' ta dash us against the rocks, Captain?”","“We can't make port here, Captain!”"]}
    );
  }
static rocks3(stage) {
    return new Bystander(
      "rocks3",
      Glyphs.Rocks3,
      8,
      {"look":"A treacherous landing for any seafarer.","bump":"{barkDetail}","barkDetail":["“Cap'n, I think we should avoid th' rocks!”","“Are y' tryin' ta dash us against the rocks, Captain?”","“We can't make port here, Captain!”"]}
    );
  }
static rocks4(stage) {
    return new Bystander(
      "rocks4",
      Glyphs.Rocks4,
      8,
      {"look":"The reams of a dozen ill-fated boats still cling to these stones.","bump":"{barkDetail}","barkDetail":["“Cap'n, I think we should avoid th' rocks!”","“Are y' tryin' ta dash us against the rocks, Captain?”","“We can't make port here, Captain!”"]}
    );
  }
static rocks5(stage) {
    return new Bystander(
      "rocks5",
      Glyphs.Rocks5,
      8,
      {"look":"Even the lightest of vessels should be wary of these shallows.","bump":"{barkDetail}","barkDetail":["“Cap'n, I think we should avoid th' rocks!”","“Are y' tryin' ta dash us against the rocks, Captain?”","“We can't make port here, Captain!”"]}
    );
  }
static rocks6(stage) {
    return new Bystander(
      "rocks6",
      Glyphs.Rocks6,
      8,
      {"look":"Dashed upon the boulders lies the wreck of an old fisher's boat.","bump":"{barkDetail}","barkDetail":["“Cap'n, I think we should avoid th' rocks!”","“Are y' tryin' ta dash us against the rocks, Captain?”","“We can't make port here, Captain!”"]}
    );
  }
static rocks7(stage) {
    return new Bystander(
      "rocks7",
      Glyphs.Rocks7,
      8,
      {"look":"These waters be a might dangerous if yer not lookin' to get y'feet wet.","bump":"{barkDetail}","barkDetail":["“Cap'n, I think we should avoid th' rocks!”","“Are y' tryin' ta dash us against the rocks, Captain?”","“We can't make port here, Captain!”"]}
    );
  }
static rocks8(stage) {
    return new Bystander(
      "rocks8",
      Glyphs.Rocks8,
      8,
      {"look":"Braver seafolk have run aground in more foolish circustances, but heed their warning nonetheless.","bump":"{barkDetail}","barkDetail":["“Cap'n, I think we should avoid th' rocks!”","“Are y' tryin' ta dash us against the rocks, Captain?”","“We can't make port here, Captain!”"]}
    );
  }
static rocks9(stage) {
    return new Bystander(
      "rocks9",
      Glyphs.Rocks9,
      8,
      {"look":"One of the rougher fishing spots for land-dwellers, not to be approach'd by sea.","bump":"{barkDetail}","barkDetail":["“Cap'n, I think we should avoid th' rocks!”","“Are y' tryin' ta dash us against the rocks, Captain?”","“We can't make port here, Captain!”"]}
    );
  }
static crab(stage) {
    return new Bystander(
      "crab",
      Glyphs.Crab,
      8,
      {"look":"A small crab seems to be trying to get your attention. {moreDetail}","bump":"You bump into a small crab, {barkDetail}","moreDetail":["You wonder what it could possibly want from you.","Its pitiful attempts at getting your attention are somehow cute. Like a small puppy trying to challenge God."],"barkDetail":["click, click, clickity, click.","*Crab Noises.*"]}
    );
  }
static quartermasterjeffrey(stage) {
    return new Bystander(
      "quartermasterjeffrey",
      Glyphs.Quartermasterjeffrey,
      8,
      {"look":"A member of the pirate crew. {moreDetail}","bump":"{barkDetail}","moreDetail":["He seems to be in an important position, but has nothing interesting about him.","This guy doesn't seem very interesting, they must be some kind of side character."],"barkDetail":["“How did you sneak on board? You'd better not cause us any trouble!”","“Captain! We got an intruder on board!”"]}
    );
  }
}

export function spawnBystanders(stage) {
  stage.spawnEntity(Bystanders.reachVillager1(), 364, 146);
  stage.spawnEntity(Bystanders.chickens4(), 287, 261);
  stage.spawnEntity(Bystanders.fisher1(), 252, 277);
  stage.spawnEntity(Bystanders.fisher2(), 286, 260);
  stage.spawnEntity(Bystanders.fisher3(), 277, 248);
  stage.spawnEntity(Bystanders.fisher4(), 234, 274);
  stage.spawnEntity(Bystanders.boot(), 310, 90);
  stage.spawnEntity(Bystanders.bruno(), 306, 159);
  stage.spawnEntity(Bystanders.chickens_2(), 294, 175);
  stage.spawnEntity(Bystanders.chickens_3(), 312, 160);
  stage.spawnEntity(Bystanders.chickens(), 301, 163);
  stage.spawnEntity(Bystanders.cow_2(), 311, 140);
  stage.spawnEntity(Bystanders.cow_3(), 318, 145);
  stage.spawnEntity(Bystanders.cow(), 251, 157);
  stage.spawnEntity(Bystanders.farmer_angry(), 253, 172);
  stage.spawnEntity(Bystanders.farmer_glad(), 277, 171);
  stage.spawnEntity(Bystanders.farmer_indifferent(), 271, 174);
  stage.spawnEntity(Bystanders.farmer_working(), 262, 168);
  stage.spawnEntity(Bystanders.oversleptPirate(), 284, 46);
  stage.spawnEntity(Bystanders.suspiciousMen1(), 2, 1);
  stage.spawnEntity(Bystanders.suspiciousMen2(), 2, 1);
  stage.spawnEntity(Bystanders.wolf1(), 0, 0);
  stage.spawnEntity(Bystanders.wolf2(), 0, 0);
  stage.spawnEntity(Bystanders.lytteltonStudent(), 368, 255);
  stage.spawnEntity(Bystanders.sumnerWorker(), 383, 308);
  stage.spawnEntity(Bystanders.Farmvillager1(), 72, 242);
  stage.spawnEntity(Bystanders.Farmvillager2(), 77, 246);
  stage.spawnEntity(Bystanders.guestroomguy(), 94, 224);
  stage.spawnEntity(Bystanders.standowner1(), 79, 270);
  stage.spawnEntity(Bystanders.standowner2(), 76, 270);
  stage.spawnEntity(Bystanders.standowner3(), 79, 276);
  stage.spawnEntity(Bystanders.standowner4(), 76, 276);
  stage.spawnEntity(Bystanders.villagekids1(), 44, 227);
  stage.spawnEntity(Bystanders.villagekids2(), 45, 227);
  stage.spawnEntity(Bystanders.villagelady1(), 36, 234);
  stage.spawnEntity(Bystanders.villagelady2(), 39, 234);
  stage.spawnEntity(Bystanders.wearhousecounterguy(), 75, 222);
  stage.spawnEntity(Bystanders.wearhouseman1(), 53, 205);
  stage.spawnEntity(Bystanders.wearhouseman2(), 58, 204);
  stage.spawnEntity(Bystanders.Miner1(), 109, 69);
  stage.spawnEntity(Bystanders.Miner2(), 106, 68);
  stage.spawnEntity(Bystanders.Miner3(), 105, 72);
  stage.spawnEntity(Bystanders.MiningVillager1(), 122, 95);
  stage.spawnEntity(Bystanders.MiningVillager10(), 137, 63);
  stage.spawnEntity(Bystanders.MiningVillager11(), 142, 67);
  stage.spawnEntity(Bystanders.MiningVillager12(), 140, 78);
  stage.spawnEntity(Bystanders.MiningVillager13(), 136, 84);
  stage.spawnEntity(Bystanders.MiningVillager14(), 145, 92);
  stage.spawnEntity(Bystanders.MiningVillager15(), 140, 102);
  stage.spawnEntity(Bystanders.MiningVillager16(), 135, 94);
  stage.spawnEntity(Bystanders.MiningVillager17(), 159, 93);
  stage.spawnEntity(Bystanders.MiningVillager18(), 150, 75);
  stage.spawnEntity(Bystanders.MiningVillager19(), 164, 87);
  stage.spawnEntity(Bystanders.MiningVillager2(), 125, 90);
  stage.spawnEntity(Bystanders.MiningVillager3(), 130, 85);
  stage.spawnEntity(Bystanders.MiningVillager4(), 121, 82);
  stage.spawnEntity(Bystanders.MiningVillager5(), 132, 94);
  stage.spawnEntity(Bystanders.MiningVillager6(), 129, 60);
  stage.spawnEntity(Bystanders.MiningVillager7(), 131, 58);
  stage.spawnEntity(Bystanders.MiningVillager8(), 128, 72);
  stage.spawnEntity(Bystanders.MiningVillager9(), 133, 71);
  stage.spawnEntity(Bystanders.MVINPC_MineChief(), 110, 73);
  stage.spawnEntity(Bystanders.dweller1(), 119, 166);
  stage.spawnEntity(Bystanders.dweller2(), 141, 145);
  stage.spawnEntity(Bystanders.dweller3(), 122, 135);
  stage.spawnEntity(Bystanders.aveline(), 3, 1);
  stage.spawnEntity(Bystanders.buriedTreasure(), 448, 390);
  stage.spawnEntity(Bystanders.canons(), 365, 189);
  stage.spawnEntity(Bystanders.debris1(), 447, 135);
  stage.spawnEntity(Bystanders.debris2(), 439, 128);
  stage.spawnEntity(Bystanders.debris3(), 429, 123);
  stage.spawnEntity(Bystanders.haunterA(), 20, 344);
  stage.spawnEntity(Bystanders.haunterG(), 22, 342);
  stage.spawnEntity(Bystanders.haunterJ(), 24, 344);
  stage.spawnEntity(Bystanders.haunterS(), 20, 342);
  stage.spawnEntity(Bystanders.haunterW(), 21, 345);
  stage.spawnEntity(Bystanders.isolationist(), 385, 49);
  stage.spawnEntity(Bystanders.isolationist2(), 436, 269);
  stage.spawnEntity(Bystanders.isolationist3(), 441, 268);
  stage.spawnEntity(Bystanders.openSea(), 463, 193);
  stage.spawnEntity(Bystanders.rocks(), 297, 249);
  stage.spawnEntity(Bystanders.rocks10(), 409, 211);
  stage.spawnEntity(Bystanders.rocks11(), 403, 107);
  stage.spawnEntity(Bystanders.rocks12(), 379, 26);
  stage.spawnEntity(Bystanders.rocks2(), 358, 251);
  stage.spawnEntity(Bystanders.rocks3(), 387, 81);
  stage.spawnEntity(Bystanders.rocks4(), 403, 175);
  stage.spawnEntity(Bystanders.rocks5(), 154, 206);
  stage.spawnEntity(Bystanders.rocks6(), 153, 219);
  stage.spawnEntity(Bystanders.rocks7(), 170, 266);
  stage.spawnEntity(Bystanders.rocks8(), 197, 175);
  stage.spawnEntity(Bystanders.rocks9(), 297, 249);
  stage.spawnEntity(Bystanders.crab(), 217, 203);
  stage.spawnEntity(Bystanders.quartermasterjeffrey(), 194, 215);
}

export default Bystanders;
